import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "알림", -1)
const _hoisted_5 = { class: "modal_close" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "modal-content" }, " 채팅방에 참여하시겠습니까? ", -1)

import {
  ref,
  onMounted,
  onUnmounted,
  computed,
  watch,
  onBeforeUnmount,
} from 'vue';
import { Modal } from 'ant-design-vue';
import { useWebSocketStore } from './stores/storeWebSocket';
import {
  tabStore,
  userStore,
  tutorialStore,
} from './stores/storeAuth';
import { routeHelper } from '@utils';
import router from '@router';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const client = useWebSocketStore();
const { pushQueryPage } = routeHelper;
const showInviteModal = ref(false);
const roomInformation = ref();

const tabData = tabStore();
const showMobileMenu = () => {
  tabData.sideMenu = true;
};

const closeInviteModal = () => {
  showInviteModal.value = false;
};

const goChatRoom = () => {
  if (client.invitingInfo.roomId) {
    client.joinChatRoom(client.invitingInfo.roomId);
    router.push({
      name: 'chatUser',
      params: { id: client.invitingInfo.roomId },
    });
  }
};

const confirmInvite = async () => {
  console.log('joinChatRoom: 채팅룸 조인 토큰');

  await client.sendToken({
    event: 'JOIN_ROOM',
    roomId: client.invitingInfo.roomId,
    data: { user_id: client.sender },
  });

  showInviteModal.value = false;
  tabData.sideMenu = false;

  // 3초 후에 goChatRoom 함수 실행
  setTimeout(() => {
    goChatRoom();
  }, 2000);
};

const rejectInvite = () => {
  console.log('isInvited Cancel');
  console.log('joinChatRoom: 채팅룸 조인 토큰');
  client.sendToken({
    event: 'REJECT_ROOM',
    roomId: client.invitingInfo.roomId,
    data: { user_id: client.sender },
  });
  showInviteModal.value = false;
};

watch(
  () => client.isInvited,
  (newValue, oldValue) => {
    console.log('watch :', newValue, oldValue);
    // 속성 값이 변경될 때 실행되는 로직
    if (newValue) {
      showInviteModal.value = true;
    }
  },
);

onBeforeUnmount(() => {
  client.disconnectWebSocket();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showInviteModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-xmark",
                  onClick: closeInviteModal
                })
              ])
            ]),
            _hoisted_6,
            _createElementVNode("div", { class: "wrap_button" }, [
              _createElementVNode("div", {
                class: "modal_cancel",
                onClick: rejectInvite
              }, " 취소 "),
              _createElementVNode("div", {
                class: "button_okay",
                onClick: confirmInvite
              }, " 수락 ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ], 64))
}
}

})